import { useCallback } from 'react';

import { StorageService } from '../../utils/storage';

type StorageValue = string | null;

/**
 * Hook para acceder al almacenamiento.
 * Usa StorageService internamente para centralizar la lógica.
 */
export const useStorage = () => {
  // Métodos para almacenamiento seguro (tokens)
  const getSecureValue = useCallback(async (key: string): Promise<StorageValue> => {
    return StorageService.getSecure(key);
  }, []);

  const setSecureValue = useCallback(async (key: string, value: string): Promise<void> => {
    return StorageService.setSecure(key, value);
  }, []);

  const removeSecureValue = useCallback(async (key: string): Promise<void> => {
    return StorageService.removeSecure(key);
  }, []);

  // Métodos para almacenamiento regular (preferencias)
  const getValue = useCallback(async (key: string): Promise<StorageValue> => {
    return StorageService.get(key);
  }, []);

  const setValue = useCallback(async (key: string, value: string): Promise<void> => {
    return StorageService.set(key, value);
  }, []);

  const removeValue = useCallback(async (key: string): Promise<void> => {
    return StorageService.remove(key);
  }, []);

  const clearAll = useCallback(async (): Promise<void> => {
    return StorageService.clearAll();
  }, []);

  return {
    // Almacenamiento seguro (para tokens)
    getSecureValue,
    setSecureValue,
    removeSecureValue,
    // Almacenamiento regular (para preferencias)
    getValue,
    setValue,
    removeValue,
    clearAll,
  };
};
